export default {
  COMMON__MINUTES: 'm',
  SENDBIRD: {
    BADGE__OVER: '+',
    MESSAGE_MENU__EDIT: 'Editar',
    BUTTON__DELETE: 'Eliminar',
    MESSAGE_STATUS__DELETE: 'Eliminar',
    MESSAGE_MENU__DELETE: 'Eliminar',
    BUTTON__SAVE: 'Guardar',
    BUTTON__CANCEL: 'Cancelar',
    BUTTON__CLOSE: 'Cerrar',
    MODAL__CHANNEL_INFORMATION__UPLOAD: 'Actualizar',
    EDIT_PROFILE__IMAGE_UPLOAD: 'Actualizar',
    CHANNEL_LIST__TITLE: 'Canal',
    CHANNEL_SETTING__HEADER__TITLE: 'Información de canal',
    MODAL__USER_LIST__TITLE: 'Miembros',
    CHANNEL_SETTING__MEMBERS__TITLE: 'Miembros',
    NO_MEMBERS: '(Sin miembros)',
    NO_NAME: '(Sin nombre)',
    TOOLTIP__UNKOWN_USER: '(Sin nombre)',
    CHANNEL_SETTING__LEAVE_CHANNEL__TITLE: 'Salir del canal',
    BUTTON__INVITE: 'Invitar',
    MODAL__INVITE_MEMBER__SELECTED: 'Seleccionado',
    MODAL__CREATE_CHANNEL__SELECTED: 'Seleccionado',
    MODAL__CHANNEL_INFORMATION__CHANNEL_NAME: 'Nombre de canal',
    MODAL__INVITE_MEMBER__TITLE: 'Añadir miembros',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER: 'Introducir',
    MESSAGE_INPUT__PLACE_HOLDER: 'Introducir',
    BUTTON__CREATE: 'Crear',
    MODAL__CREATE_CHANNEL__TITLE: 'Canal nuevo',
    TRYING_TO_CONNECT: 'Tratar de conectar...',
    USER_PROFILE__MESSAGE: 'Mensaje',
    USER_PROFILE__USER_ID: 'ID de usuario',
    EDIT_PROFILE__USERID_LABEL: 'ID de usuario',
    EDIT_PROFILE__TITLE: 'Mi perfil',
    EDIT_PROFILE__IMAGE_LABEL: 'Imagen de perfil',
    EDIT_PROFILE__NICKNAME_LABEL: 'Apodo',
    EDIT_PROFILE__THEME_LABEL: 'Tema oscuro',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER__DISABLED: 'Chat no está dismponible en este canal.',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: 'Nuevos mensaje[s] desde',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__ON: 'Activado',
    CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS: 'Todos los miembros',
    CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: 'Invitar usuarios',
    MODAL__DELETE_MESSAGE__TITLE: '¿Quiere borrar este mensaje?',
    MODAL__CHANNEL_INFORMATION__TITLE: 'Editar información de canal',
    MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE: 'Imagen de canal',
    MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER: 'Ingrese nombre.',
    TYPING_INDICATOR__IS_TYPING: 'Escribiendo a máquina...',
    TYPING_INDICATOR__ARE_TYPING: 'Escribiendo a máquina...',
    TYPING_INDICATOR__MULTIPLE_TYPING: 'Escribiendo a máquina...',
    TYPING_INDICATOR__AND: 'y',
    MESSAGE_STATUS__SENDING_FAILED: 'No se pudo enviar mensaje.',
    MESSAGE_STATUS__TRY_AGAIN: 'Reintente',
    MESSAGE_STATUS__OR: 'o',
    PLACE_HOLDER__WRONG: 'Algo salió mal.',
    PLACE_HOLDER__RETRY_TO_CONNECT: 'Reintentar',
    NO_TITLE: 'Sin título',
    TOOLTIP__AND_YOU: ', y ud.',
    TOOLTIP__YOU: 'Ud.',
    UNKNOWN__UNKNOWN_MESSAGE_TYPE: '(Tipo de mensaje desconocido)',
    UNKNOWN__CANNOT_READ_MESSAGE: 'Incapaz de leer este mensaje.',
    MESSAGE_EDITED: '(editado)',
    PLACE_HOLDER__NO_CHANNEL: 'Iniciar una nueva conversación',
    MESSAGE_MENU__REPLY: 'Responder',
    QUOTED_MESSAGE__REPLIED_TO: '→',
    QUOTE_MESSAGE_INPUT__REPLY_TO: '',
    QUOTED_MESSAGE__CURRENT_USER: 'Ud.',
    MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER: 'Responder a un mensaje',
    CHANNEL_SETTING__PROFILE__EDIT: 'Editar',
    MESSAGE_MENU__COPY: 'Copiar',
  },
  TERMS_IMPRESSUM: 'Impressum',
  TERMS_DATENSCHUTZ: 'Datenschutz',
  CONFIRM: 'Aceptar',
  SETTINGS__NONE: 'Ninguno',
  SEARCH__USER_PLACEHOLDER: 'Nombre/Número de empleado/Teléfono',
  SEARCH__NO_USER_INFO: 'No hay información de usuario.',
  LOGIN__EMAIL_OR_HP: 'Correo o número de teléfono',
  ELECTRON: {
    MENU_DELETE: 'Eliminar',
    MENU_VIEW: 'Ver',
    MENU_SIGN_OUT: 'Cerrar Sesión',
    MENU_SETTINGS: 'Ajustes',
    MENU_CLOSE: 'Cerrar',
    MENU_SELECT_ALL: 'Elegir todos',
    MENU_FILE: 'Archivos',
    MENU_ABOUT: 'Sobre {0}',
    MENU_UPDATE: 'Compruebe Actualización',
    MENU_HIDE: 'Esconder {0}',
    MENU_HIDE_OTHERS: 'Esconder Otros',
    MENU_SHOW_ALL: 'Mostrar todo',
    MENU_QUIT: 'Acabar {0}',
    MENU_NEW_CHANNEL: 'Canal nuevo',
    MENU_UNDO: 'Deshacer',
    MENU_REDO: 'Rehacer',
    MENU_CUT: 'Corte',
    MENU_PASTE: 'Pegar',
    MENU_PASTE_AND_MATCH_STYLE: 'Pegar Estilo',
    MENU_RELOAD: 'Recarga',
    MENU_FORCE_RELOAD: 'Recarga forzada',
    MENU_FULL_SCREEN: 'Alternar pantalla completa',
    MENU_RESET_ZOOM: 'Tamaño real',
    MENU_ZOOM_IN: 'Zoom in',
    MENU_ZOOM_OUT: 'Zoom out',
    MENU_WINDOW: 'Window',
    MENU_MINIMIZE: 'Disminuir al máximo',
    MENU_ZOOM: 'Engrandecer al máximo',
    MENU_HELP: 'Ayuda',
    MESSAGE_UP_TO_DATE: 'Actualmente estás usando la última versión.',
    UPDATE_AVAILABLE: 'Actualización disponible',
    MESSAGE_UPDATE_AVAILABLE: 'Hay disponible una actualización a la última versión.',
    MENU_EDIT: 'Editar',
    MENU_COPY: 'Copiar',
    UP_TO_DATE: 'Última versión',
  },
  LOGIN__INSERT_EMAIL_HP: 'Introduzca su correo electrónic o número de teléfono.',
  LOGIN__PASSWORD_GUIDE_SUBTITLE:
    'Si ha olvidado su contraseña, Intente restablecer su contraseña en la página de inicio de sesión de la App de su móvil.',
  LOGIN__INSERT_PASSWORD: 'Introduzca su contraseña.',
  LOGIN__PASSWORD_INFORMATION: '¿Ha olvidado su contraseña?',
  BEFORE: 'Antes',
  ALERT__NO_ONE_SELECTED: 'No hay personal seleccionado.',
  BASIC__: {
    ERROR: 'Hay un error.<br /> Por favor intente de nuevo.',
    MSG__: { INPUT: 'Ingrese su búsqueda' },
    PWD_ALL_VALIDATION:
      'La contraseña debe ser una combinación de %1$@~%2$@ letras mayúsculas/minúsculas, núemros y némeros especiales.',
    RETRY: 'Reintentar',
    PASSWORD_RULE: '8-20 carácteres y contiene letras, números y símbolos.',
    HAS_ATTENDANCE_HISTORY_VIEW_RIGHT: '¿Autorizado para ver el historial de asistencia personal?',
  },
  LOGOUT: 'Cerrar Sesión',
  COMMON__SECONDS: 'Segundos',
  SCHEDULE__: {
    GUIDE__: {
      IF_YOU_STOP_UNSAVED: 'Si para la edición, no se guardarán la modificaciones.',
      ARE_YOU_SURE_WANT_TO_STOP: '¿Está seguro de que desea parar la edición del calendario?',
    },
  },
  TEMPLATE__: { GUIDE__: { NO_TEMPLATE_REGISTERED: 'No hay plantilla registrada.' } },
  AWAY_TIME: 'h',
  SETTINGS__CHANGE_LANGUAGE: 'Idioma',
  SEARCH__MEMBER_PLACEHOLDER: 'Nombre/Nº de empleado/Teléfono',
  ' ': 'Si configura para ´No usar´, la función de gestión de embarazo/posparto será deshabilitado y Ud. no podrá ver registros relacionados.',
  BASIC__UNKNOWN: 'Desconocido',
  LOGIN__SERVER_ALERT: 'Incapaz de conectar al servidor.',
  MSG__: {
    ERROR__: {
      UPDATE_CHANNEL_INFO: 'Incapaz de actualizar canal.',
      LEAVE_CHANNEL: 'Incapaz de salir del canal.',
      CREATE_CHANNEL: 'No se puede crear el canal.',
    },
    FILE__: { MAXIMGSIZE: 'Excede límite de talla de archivo.' },
    ALLOW_BROWSER_ALARM:
      'Permita notificaciones en la configuración de su navegador para recibir mensajes de notificación.',
    LABEL__: { SEARCH_MESSAGE: 'Buscar mensajes' },
    GUIDE__: { SEARCH_MESSAGE: 'Busque el mensaje que desea encontrar en {0}.' },
    BASIC__: { NO_SEARCH_RESULT: 'No hay resultados.' },
  },
  INVITE__MEMBER_SELECTION: 'Elegir miembros',
  CHANNEL__EDIT_CHANNEL_NAME_GUIDE: 'El nombre cambiado será visible a todos participantes del canal.',
  NOTICE: 'Notificaciones',
  INVITE__CREATE: 'Crear',
  CHANNEL__LEAVE_THIS_CHANNEL: '¿Quiere salir del canal?',
  LOGIN__PASSWORD_FAIL_COUNT: 'Ud. ha ingresado la contraseña incorrecta {0} veces.',
  LOGIN__FAIL_ALERT: 'Será bloqueado por 5 minutos después de 5 intentos incorrectos consecutivos.',
  LOGIN__LOCK_STATE_ALERT: 'Bloqueado durante 5 minutos después de 5 contraseñas incorrectas consecutivas.',
  LOGIN__RETRY_ALERT: 'Por favor reinténtelo después de {0}.',
  LOGIN__PASSWORD_GUIDE_TITLE: 'Contraseña de ShoplaChat es lo mismo que la contraseña de aplicación móvil.',
  SETTINGS__ALL_MESSAGES: 'Notificaciones en todos los mensajes nuevos',
  SETTINGS__ALARM_SOUND: 'Sonido',
  SETTINGS__SOUND_ALARM: 'Sonido de notificación',
  SETTINGS__LISTEN_ALARM_SOUND: 'Escuchar',
  ALERT__MAX_INVITE_MEMBER: 'El número máximo de gente que pueden unise al canal es 20,000.',
  LOGIN__DEACTIVATED_ALERT: 'No se puede iniciar sesión porque el administrador desactivó la función de chat.',
  LOGIN__SERVER_ALERT_CONTENTS:
    'No se puede iniciar sesión debido a la red inestable. Háganos el favor de comprobar la conexión de red y reinténtelo.',
  LOGIN__LOGOUT_ALERT: 'Ud. ha sido desconectado.',
  CHANNEL__EDIT_CHANNEL_NAME: 'Cambio de nombre de canal',
  SETTINGS__THEME: 'Tema',
  SETTINGS__LANGUAGE: 'Idioma',
  SETTINGS__LIGHT_THEME: 'Claro',
  SETTINGS__DARK_THEME: 'Oscuro',
  SEARCH__CHANNEL_PLACEHOLDER: 'Nombre de empleado',
  CHANNEL__CONTACT: '1:1 Chat',
  BASIC: { LABEL: { MAXIMAGECNT: 'Pueden ser registradas hasta {0} imágenes.' } },
  LOGIN__LOGIN_FAILED: 'ID o contraseña son incorrectas.',
  FORGOT_PW: '¿Olvidó su contraseña?',
  BASIC__MAX_FORMAT_INPUT: 'Se pueden ingresar carácteres de máximo de %@.',
  SERVICE__COMING_SOON: 'Se proporcionará pronto.',
  LOGIN__GUIDE: 'Puede iniciar sesión con la cuenta en la aplicación.',
  MOBILE__: {
    ACCESS_PC: 'Acceda al tablero desde el PC!',
    ACCESS_DESC_01: 'El tablero está optimizado para el entorno de PC.',
    ACCESS_DESC_02: 'Intente acceder desde un PC para su experiencia fluida.',
    ACCESS_PC_ONLY: 'Intente acceder desde PC.',
    GUIDE: 'La función de chat está dismpo ible en su PC o aplicación móvil.',
  },
  CHANNEL__NO_CHAT_HISTORY: 'Sin conversaciones',
  LOGIN: 'Iniciar Sesión',
  LOGIN__PASSWORD: 'Contraseña',
  SEARCH__NO_RESULT: 'No hay resultados.',
  BASIC__SEARCH: 'Buscar',
};
